<template>
  <div class="content-card">
    <sc-text tag="h2" v-if="fields && fields.title" :field="fields.title" />
    <sc-text tag="h3" v-if="fields && fields.subtitle" :field="fields.subtitle" />
    <sc-text tag="p" v-if="fields && fields.content" :field="fields.content" />
    <sc-rich-text v-if="fields && fields.additionalcontent" :field="fields.additionalcontent" />
    <sc-link
      v-if="fields && fields.cta && fields.cta.value && fields.cta.value.text"
      :field="fields.cta"
      class="c-cta--secondary"
      :class="fields.cta.value.class"
    />
  </div>
</template>

<script>
import { Text, RichText, Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Card',
  components: {
    ScText: Text,
    ScRichText: RichText,
    ScLink: Link
  },
  props: {
    fields: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>
<style lang="scss" scoped>
.content-card {
  width: 100%;
  @include add-Shadow;
  @include margin-x(0);
  padding: 2.5rem 2.5rem 3rem 2.5rem;

  @include tablet-up {
    display: flex;
    flex-flow: column nowrap;
    width: calc(100% / 2 - 2rem);
    @include margin-x(0, 4rem);
    margin-top: 4rem;
  }

  &:nth-child(even) {
    margin-right: 0;
  }

  .c-cta--secondary {
    margin-top: auto;
    margin-bottom: 0;
  }

  &:deep() {
    ul {
      margin-top: 1rem !important;

      li {
        padding-bottom: 1rem;
      }
    }
  }
}
</style>
